<div class="modal-header">
    <h4 class="mb-0">
        Rebook Booking
    </h4>
    <button
        type="button"
        class="btn btn-close"
        (click)="dismiss()"
    >
    </button>
</div>
<div
    class="modal-body p-3"
    [formGroup]="form"
>
    <div class="px-3 vstack gap-3">
        <p class="text-muted mb-0">
            Create copies of this booking for new dates. The booking details (contact, party size, duration, tables, notes) will be copied.
        </p>
        <div class="vstack gap-2">
            <label class="mb-0 form-label fw-semibold">
                New Booking Dates
            </label>
            <div
                formArrayName="dates"
                class="vstack gap-2"
            >
                @for (date of dates.controls; track dateIds[$index]; let i = $index) {
                    <div class="hstack gap-2">
                        <input
                            [formControlName]="i.toString()"
                            type="date"
                            class="form-control"
                        >
                        <button
                            type="button"
                            class="btn btn-outline-danger"
                            (click)="removeDate(i)"
                            [disabled]="dates.length === 1"
                        >
                            <i class="bi bi-trash"></i>
                        </button>
                    </div>
                }
            </div>
            <button
                type="button"
                class="btn btn-outline-secondary align-self-start"
                (click)="addDate()"
            >
                <i class="bi bi-plus"></i>
                Add Date
            </button>
        </div>
        <hr class="my-2"/>
        <div class="vstack gap-1">
            <span class="fw-semibold">Booking Details to Copy:</span>
            <small class="text-muted">
                Contact: {{ sourceBooking.contact.firstName }} {{ sourceBooking.contact.lastName }}
            </small>
            <small class="text-muted">
                Party Size: {{ sourceBooking.size }}
            </small>
            <small class="text-muted">
                Time: {{ formattedTime }}
            </small>
            <small class="text-muted">
                Duration: {{ sourceBooking.duration }} minutes
            </small>
            <small class="text-muted">
                Tables: {{ tableNames }}
            </small>
            @if (reasonName) {
                <small class="text-muted">
                    Reason: {{ reasonName }}
                </small>
            }
        </div>
    </div>
</div>
<div class="modal-footer">
    <button
        type="button"
        class="btn btn-outline-secondary"
        (click)="dismiss()"
    >
        Cancel
    </button>
    <button
        type="button"
        class="btn btn-primary"
        (click)="rebookBooking()"
        [disabled]="form.invalid || isSubmitting"
    >
        @if (isSubmitting) {
            <span class="spinner-border spinner-border-sm me-1" role="status"></span>
        }
        Create {{ dates.length }} Booking{{ dates.length > 1 ? 's' : '' }}
    </button>
</div>
